import React, { Fragment, useContext, useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ContentApp from '../../../components/ContentApp';
import { fetchReservation } from '../../../helpers/reservation';
import { WelletContext } from '../../../context/WelletContext';
import { getQueryString } from '../../../helpers/url';
import useForm from '../../../helpers/useForm';
import { ButtonStatus } from '../../../components/Common/ButtonProccessing/ButtonProccessing';
import { isValidPhoneNumber } from 'react-phone-number-input';
import EventHeader from '../../../components/Common/EventHeader/EventHeader';
import ReservationCheckCustomerInfo from '../../../components/ReservationCheck/ReservationCheckCustomerInfo/ReservationCheckCustomerInfo';
import { CircleSpinner } from 'react-spinners-kit';
import { convertTime12to24, getDatePerformance } from '../../../helpers/dates';
import Modal from '../../../components/Common/Modal/Modal';
import Button from '../../../components/Common/Button/Button';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';
import PaymentForm from '../../../components/PaymentForm/PaymentForm';
import ContentBottom from '../../../components/ContentBottom';
import PerformanceSelector from '../../../components/PerformanceSelector/PerformanceSelector';
import EmptyActivity from '../../../components/Common/EmptyActivity/EmptyActivity';
import VoucherRedemption from '../../../components/VoucherRedemption/VoucherRedemption';
import SummaryProducts from '../../../components/ReservationCheck/Summary/SummaryProducts';
import Summary from '../../../components/ReservationCheck/Summary/Summary';
import { formatLocation } from '../../../helpers/format';
import AffiliateDiscount from '../../../components/ReservationCheck/AffiliteDiscount/AffiliateDiscount';
import {
  setSellerDiscount,
  setVoucherCode,
  resetVoucherCode,
} from '../../../actions/reservationActions';
import Commission from '../../../components/ReservationCheck/Commission/Commission';
import GroupName from '../../../components/ReservationCheck/GroupName/GroupName';
import ShareReservation from '../../../components/ReservationCheck/ShareReservation/ShareReservation';
import Loading from '../../../components/Loading/Loading';
import { sendMessageToParent } from '../../../helpers/iframe';
import SuccessReservation from '../../../components/ReservationCheck/SuccessReservation/SuccessReservation';

const ReservationCheckTickets = ({ history }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const app = useSelector((state) => state.app);
  const reservation = useSelector((state) => state.reservation);
  const associate = useSelector((state) => state.associates);
  const user = associate.user;
  const isCustomer = user?.roles?.includes('customer');
  const [loadingReservation, setLoadingReservation] = useState(true);
  const currency = useSelector((state) => state.currency.selected.shortForm);
  const idReservation = getQueryString('id');
  const countryCode = useSelector((state) => state.app.currentMarket.countryCode);

  const [loadingEvent, setLoadingEvent] = useState(true);
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const [reservationInfo, setReservationInfo] = useState(null);
  const [originalReservation, setOriginalReservation] = useState(null);
  const [paxs, setPaxs] = useState(reservation.paxs);
  const hasProducts = reservation.products?.length > 0;
  const [initialNoAvailabilityError, setInitialNoAvailabilityError] = useState(null);
  const [selectedPerformance, setSelectedPerformance] = useState(null);
  const [error, setError] = useState(null);
  const [phoneError, setPhoneError] = useState('');
  const [reservationDate, setReservationDate] = useState(null);
  const eventId = getQueryString('eventId');
  const [eventDetail, setEventDetail] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingSchedule, setLoadingSchedule] = useState(true);
  const [intervals, setIntervals] = useState([]);
  const [discountCode, setDiscountCode] = useState(null);
  const showPerformanceSelector =
    reservationInfo?.reservationType === 'TICKET' ? false : eventDetail?.includeAvailability;

  const [voucherStatus, setVoucherStatus] = useState(null);
  const [voucherErrorCode, setVoucherErrorCode] = useState(null);

  const [reservationSuccess, setReservationSuccess] = useState(false);
  const [reservationResult, setReservationResult] = useState(null);

  const [processingReservation, setProcessingReservation] = useState(false);

  const getReservation = async (voucherCode) => {
    try {
      const result = await fetchReservation({
        welletContext,
        reservation,
        language,
        refReservationId: idReservation,
        eventId: parseInt(eventId),
        voucherCode: voucherCode,
        sellerDiscount: reservation.sellerDiscount ?? null,
        customerCurrency: currency,
        reservationTransferRequest: reservation?.transfer ?? null,
      });

      if (!result.success) {
        throw new Error(result.errorMessage);
      }

      const data = result.data;
      setReservationInfo(data);

      if (data?.date) {
        const parsedDate = new Date(`${data.date}T00:00:00`);
        if (!isNaN(parsedDate)) setReservationDate(parsedDate);
      }

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setLoadingReservation(false);
    }
  };

  const getOriginalReservation = async () => {
    //setLoading(true);
    try {
      const response = await welletContext.apis.tickets.get(
        `/Reservation/${idReservation}?lang=${language}`,
      );
      setOriginalReservation(response.data);
      setInitialValues(response.data);
      setPaxs(response.paxs);
      //setSelectedPerformance(format(new Date(response.data.reservationLocalDate), 'H:mm'));
    } catch (error) {
      console.error(error);
    } finally {
      //setLoading(false);
    }
  };

  const getSchedule = async () => {
    setLoadingSchedule(true);
    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/GetScheduleEvent?eventId=${eventId}&reservationType=AREA`,
      );
      if (result.data.schedules.length === 0) {
        setIntervals([]);
      }
      const formattedTimes = result.data.schedules.map((time) => {
        const time24 = new Date(reservation.date + 'T' + convertTime12to24(time.timeStart));
        if (time.timeMinutesStart >= 0 && time.timeMinutesStart <= 360)
          time24.setDate(time24.getDate() + 1);
        return { time24, soldOut: time.isSoldOut };
      });
      formattedTimes.sort();
      const allIntervals = formattedTimes.map(({ time24, soldOut }) => ({
        time: time24,
        soldOut,
      }));
      setIntervals(allIntervals);
      setLoadingSchedule(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getReservationAndSchedule = async () => {
    setLoadingSchedule(true);
    const reservation = await getReservation();
    if (reservation.isAvailable === false) {
      setInitialNoAvailabilityError(t('reservationError.NO_AVAILABILITY'));
    } else {
      getSchedule(reservation.availability);
    }
    setLoadingSchedule(false);
  };

  const getEventDetails = async () => {
    setLoadingEvent(true);
    try {
      const response = await welletContext.apis.tickets.get(
        `/shows/event/${eventId}?lang=${language}`,
      );
      setEventDetail(response.data);
    } catch (error) {
      console.error(error);
    }
    setLoadingEvent(false);
  };

  const setInitialValues = (reservation) => {
    handleChange(null, 'customerName', reservation.customerFirstName);
    handleChange(null, 'customerLastname', reservation.customerLastName);
    handleChange(null, 'phone', reservation.customerPhone);
  };

  const handleConfirmAction = () => {
    setIsModalOpen(false);
    sendForm();
  };

  const onVoucherApply = async (code) => {
    setVoucherStatus('VALIDATING');
    setVoucherErrorCode(null);

    try {
      await getReservation(code);
      setDiscountCode(code);
      dispatch(setVoucherCode(code));
      setVoucherStatus('VALID_COUPON');
    } catch (error) {
      if (error.response?.data?.errorType === 'PROMOTION_ERROR') {
        setVoucherErrorCode(error.response.data.errorMessage);
      } else {
        setVoucherErrorCode(error.message);
      }

      setVoucherStatus(null);
    }
  };

  const onVoucherRemove = async () => {
    setDiscountCode(null);
    setVoucherStatus(null);
    setVoucherErrorCode(null);
    dispatch(resetVoucherCode());
    await getReservation();
  };

  const onApplyDiscount = (discount) => {
    dispatch(setSellerDiscount(discount));
  };

  function validate(values) {
    let errors = {};

    if (!originalReservation && !reservationInfo.requiresPayment) {
      //todo: cambiar la respuesta de la reserva original desde la api. Tiene que retornar el objeto customer
      if (!values.customerName) {
        errors.customerName = t('nameError.EMPTY_NAME');
      } else if (/\d/.test(values.customerName)) {
        errors.customerName = t('nameError.NOT_NUMBERS');
      }
      if (!values.email) {
        errors.email = t('emailError.EMPTY_EMAIL');
      } else if (!/\S+@\S+\.\S+/.test(values.email)) {
        errors.email = t('emailError.INVALID_EMAIL');
      }
      if (!values.customerLastname) {
        errors.customerLastname = t('nameError.EMPTY_LASTNAME');
      } else if (/\d/.test(values.customerLastname)) {
        errors.customerLastname = t('nameError.NOT_NUMBERS');
      }
      if (!values.phone) {
        errors.phone = t('phoneError.EMPTY_PHONE_NUMBER');
        setPhoneError(errors.phone);
      } else {
        setPhoneError('');
      }
      if (values.phone && !isValidPhoneNumber(values.phone)) {
        errors.phone = t('phoneError.INVALID_PHONE_NUMBER');
        setPhoneError(errors.phone);
      }
    }
    if (showPerformanceSelector && !selectedPerformance) {
      errors.performance = t('selectArrivalTime');
    }

    return errors;
  }

  const sendForm = async () => {
    if (reservationInfo.totalAmount === 0 && !isModalOpen) {
      setIsModalOpen(true);
      return;
    } else {
      setProcessingReservation(true);
      try {
        let url = '/reservation/GenerateReservation';
        if (reservationInfo && idReservation) {
          url = '/reservation/modifyreservation';
        }

        const reservationLocalTime = showPerformanceSelector
          ? getDatePerformance(reservation.date, selectedPerformance)
          : eventDetail.startDate;

        var customer = {
          firstName: values.customerName,
          lastName: values.customerLastname,
          phone: values.phone,
          email: values.email,
        };

        const result = await welletContext.apis.tickets.put(url, {
          showId: reservation.showId,
          paxs: paxs,
          language: language,
          customer: !reservationInfo.requiresPayment ? customer : null,
          comments: null,
          occasion: null,
          countryCode: values.countryCode ?? 'MX',
          reservationDateLocalTime: reservationLocalTime,
          totalAmount: reservationInfo?.payment.remainingDepositAmountInMarketCurrency ?? null,
          products: reservation.products ?? null,
          oldReservationId: idReservation,
          eventId: eventId,
          voucherCode: discountCode,
          customerCurrency: currency,
          reservationTransferRequest: reservation.transfer ?? null,
          sellerDiscount: reservation.sellerDiscount,
          eventName: values.groupName ?? null,
        });

        setReservationSuccess(true);
        setReservationResult(result.data);

        // setTimeout(() => {
        //   history.push(
        //     reservationInfo.totalAmount === 0
        //       ? '/reservation-success-courtesy'
        //       : `/reservation-success?reservationType=${result.data.reservationType}&status=${result.data.status}`,
        //   );
        // }, 1500);
      } catch (error) {
        let errorMessage;
        switch (error.response.data.errorType) {
          case 'GENERIC_ERROR':
            errorMessage = t('reservationError.GENERIC_ERROR');
            break;
          case 'SHOW_NOT_FOUND':
            errorMessage = t('reservationError.SHOW_NOT_FOUND');
            break;
          case 'SCHEDULE_SOLD_OUT':
            errorMessage = t('reservationError.SCHEDULE_SOLD_OUT');
            break;
          case 'INVALID_RESERVATION_DATE':
            errorMessage = t('reservationError.INVALID_RESERVATION_DATE');
            break;
          case 'NO_AVAILABILITY':
            errorMessage = t('reservationError.NO_AVAILABILITY');
            break;
          case 'DUPLICATE_RESERVATION':
            errorMessage = t('reservationError.DUPLICATE_RESERVATION');
            break;
          case 'SALES_EVENT_END':
            errorMessage = t('reservationError.NO_AVAILABILITY');
            break;
          case 'PROMOTION_ERROR':
            errorMessage = t('promotionError.' + error.response.data.message);
            break;
          case 'PURCHASE_RULE_NOT_SATISFIED':
            errorMessage = t('reservationError.PURCHASE_RULE_NOT_SATISFIED');
            break;
          default:
            errorMessage = t('reservationError.GENERIC_ERROR');
        }
        setError(errorMessage);
      } finally {
        setProcessingReservation(false);
      }
    }
  };

  let { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  const renderAvailableDiscounts = () => {
    if (!reservationInfo.availableDiscounts || reservationInfo.availableDiscounts.length === 0)
      return null;

    return (
      <div className='mt-4'>
        <AffiliateDiscount
          onApplyDiscount={(e) => onApplyDiscount(e)}
          discounts={reservationInfo.availableDiscounts}
        />
      </div>
    );
  };

  const renderReservationSuccess = () => {
    return (
      <div className='mt-5'>
        {reservationInfo.requiresPayment ? (
          <ShareReservation
            link={reservationResult?.paymentLink}
            expirationDate={reservationResult?.paymentExpirationDate}
          />
        ) : (
          <SuccessReservation />
        )}
      </div>
    );
  };

  const renderRerservationForm = () => {
    return (
      <>
        <div className='mt-4'>
          <SummaryProducts reservationInfo={reservationInfo} />
        </div>
        {renderAvailableDiscounts()}
        <div className='mt-4'>
          <VoucherRedemption
            onApplyVoucher={(e) => onVoucherApply(e)}
            onRemoveVoucher={() => onVoucherRemove()}
            status={voucherStatus}
            errorCode={voucherErrorCode}
          />
        </div>

        <div className='mt-4'>
          <Summary reservation={reservationInfo} />
        </div>

        {reservationInfo.commission && reservationInfo.commission.subtotal > 0 && (
          <div className='mt-4'>
            <Commission
              subtotal={reservationInfo.commission.subtotal}
              percentage={reservationInfo.commission.percentage}
              discount={reservationInfo.commission.discountAmount}
              discountPercentage={reservationInfo.commission.discountPercentage}
              total={reservationInfo.commission.total}
            />
          </div>
        )}

        <div className='mt-4'>
          {reservationInfo.requiresPayment ? (
            <>
              <GroupName onChangeName={(e) => handleChange(null, 'groupName', e)} />
              <ContentBottom>
                <div className='mt-4'>
                  <button className='btn btn-primary w-100' onClick={handleSubmit}>
                    {reservationInfo.totalAmount === 0
                      ? t('generateTickets')
                      : t('generatePaymentLink')}
                  </button>

                  {reservationInfo.totalAmount !== 0 && (
                    <div className='mt-2'>
                      <button className='btn btn-secondary w-100' onClick={handleSubmit}>
                        {t('showQRToCollectInPerson')}
                      </button>
                    </div>
                  )}
                </div>
              </ContentBottom>
            </>
          ) : (
            <>
              <ReservationCheckCustomerInfo
                handleChange={handleChange}
                values={values}
                errors={errors}
                phoneError={phoneError}
                setPhoneError={setPhoneError}
                countryCode={countryCode}
              />
              <ContentBottom>
                <div className='mt-4'>
                  <button className='btn btn-primary w-100' onClick={handleSubmit}>
                    {reservationInfo.totalAmount === 0
                      ? t('generateTickets')
                      : t('generatePaymentLink')}
                  </button>
                </div>
              </ContentBottom>
            </>
          )}
        </div>

        {!isCustomer && (
          <Fragment>
            {originalReservation?.customerName ? (
              <>
                <span className='fw-semibold text-primary font-tiny'>
                  {t('reservationInformation')}
                </span>
                <div className='mt-2 text-secondary text-small'>{t('bookingHolder')}</div>
                <span className='font-medium fw-semibold mt-1 '>
                  {originalReservation?.customerName}
                </span>
                {originalReservation?.reservationOccasion && (
                  <>
                    <div className='mt-3 text-secondary text-small'>{t('bookingHolder')}</div>
                    <span className='text-tertiary fw-semibold mt-1'>
                      {originalReservation?.reservationOccasion}
                    </span>
                  </>
                )}
                {originalReservation?.reservationComments && (
                  <>
                    <div className='mt-3 text-secondary text-small'>{t('specialRequest')}</div>
                    <span className='text-tertiary fw-semibold mt-1'>
                      {originalReservation?.reservationComments}
                    </span>
                  </>
                )}
              </>
            ) : null}
            {showPerformanceSelector && (
              <>
                <div className='fw-semibold text-primary font-tiny mt-3'>{t('arrivalTime')}</div>
                {intervals.length ? (
                  <>
                    <div className='mt-3 mb-3'>
                      <PerformanceSelector
                        performances={intervals}
                        onHandleChange={setSelectedPerformance}
                        defaultPerformance={selectedPerformance}
                      />
                    </div>
                    {errors.performance && (
                      <div
                        className='errorLabel mt-2 position-relative error-label'
                        style={{ color: '#fff' }}
                      >
                        <span></span> {errors.performance}
                      </div>
                    )}
                  </>
                ) : (
                  <div className='mt-3'>
                    <EmptyActivity title={t('noSchedule')} />
                  </div>
                )}
              </>
            )}
            {error && (
              <div className='mt-4'>
                <>
                  <ErrorBox title={error} />
                  <div className='mt-4 text-center text-primary' onClick={() => history.goBack()}>
                    {t('reschedule')}
                  </div>
                </>
              </div>
            )}
          </Fragment>
        )}

        {isModalOpen && (
          <Modal title={t('confirmAction')} onClose={() => setIsModalOpen(false)} hasBackground>
            <div className='text-white text-center fw-semibold'>
              {t('courtesyTicketsMessage', {
                currency,
              })}
            </div>
            <Button
              size='medium'
              status={ButtonStatus.Normal}
              text={t('confirm')}
              onClick={handleConfirmAction}
              className='mt-4'
            />
            <Button
              size='medium'
              status={ButtonStatus.Normal}
              text={t('cancel')}
              onClick={() => setIsModalOpen(false)}
              className=' mt-2'
              backgroundColor='#fff'
              color='#000'
            />
          </Modal>
        )}

        {isCustomer && reservationInfo && (
          <div className='content-botton p-0'>
            <PaymentForm reservation={reservationInfo} products={reservation.products} />
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    if (reservation.sellerDiscount !== null) {
      getReservation(reservation.voucherCode);
    }
  }, [reservation?.sellerDiscount]);

  useEffect(() => {
    handleChange(null, 'language', language);
    if (reservation.date && reservation.performance) {
      setReservationDate(new Date(reservation.date + 'T' + reservation.performance));
    }

    if (hasProducts && currency) {
      getReservationAndSchedule();
    }
  }, [currency]);

  useEffect(() => {
    getEventDetails();

    if (idReservation) getOriginalReservation();
  }, []);

  return (
    <>
      {loadingEvent || loadingReservation ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <>
          <Header />
          <ContentApp classes='pb-0'>
            {initialNoAvailabilityError ? (
              <>
                <ErrorBox title={initialNoAvailabilityError} />
                <div className='mt-4 text-center text-primary' onClick={() => history.goBack()}>
                  {t('reschedule')}
                </div>
              </>
            ) : (
              <>
                <EventHeader
                  eventImg={eventDetail.bannerImage}
                  eventName={eventDetail.name}
                  eventDescription={
                    eventDetail.show.name + ' · ' + formatLocation(eventDetail.show.city.nameLong)
                  }
                  eventDate={eventDetail.startDate}
                  eventEndDate={eventDetail.endDate}
                />
                {reservationSuccess ? renderReservationSuccess() : renderRerservationForm()}
              </>
            )}
          </ContentApp>

          {reservationSuccess && (
            <div
              className='d-flex mt-3'
              style={{ paddingBottom: 'calc(30px + env(safe-area-inset-top))' }}
            >
              <div class='container'>
                <div class='row justify-content-center '>
                  <div class='col-12 col-md-7 col-lg-6'>
                    <div className='px-3'>
                      <button
                        className='btn btn-primary w-100'
                        onClick={() =>
                          app.isEmbedded
                            ? sendMessageToParent(window, {
                                type: 'RESERVATION_SUCCESS',
                              })
                            : history.push('/')
                        }
                      >
                        {t('backToHome')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <Loading show={processingReservation} text={t('generatingPaymentLink')} />
        </>
      )}
    </>
  );
};
export default ReservationCheckTickets;
